<template>
  <div>
      <base-alert type="danger" dismissible :visible="error != ''">
          <span class="alert-inner--text">{{ $t(error) }}</span>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <loading-panel :visible="loading"></loading-panel>
    <div class="header pb-8 pt-4 pt-lg-5 d-flex profile-header"
        style="min-height: 100vh; background-image: url(img/theme/header-background.png); background-size: cover; background-position: center top;"
    >
      <b-container fluid class="mt-6">
        <b-row align-v="center">
          <b-col cols="6">
            <h4 class="display-4 text-dark">{{ $t('admin.carousel.pageTitle') }}</h4>
          </b-col>
          <b-col cols="6" align="right">
            <h4>
                <router-link class="display-5 text-white" to="/blogs">
                    &larr;&nbsp;&nbsp;{{ $t('admin.back') }}
                </router-link>
            </h4>            
          </b-col>          
        </b-row>
        <b-row>
          <b-col xl="12">
            <card>
              <b-row align-v="center" slot="header" >
                <b-col cols="12" md="12">
                  <b-row align-v="center">
                      <b-col cols="7">
                          <h3 class="mb-0">{{ $t('admin.carousel.addtitle') }}</h3>
                      </b-col>
                      <b-col cols="5" class="text-right pr-0">
                        <b-col v-bind:style="styles.flagColStyle">
                          <el-tooltip placement="bottom" :content="$t('tooltip.language.fr')">
                            <b-link @click="onTranslate('fr')"><country-flag country='fr' size='normal' v-bind:style="lang=='fr'? styles.flagFocusStyle:styles.flagNotFocusStyle"/></b-link>
                          </el-tooltip>
                          <a href="javascript:void(0)" class="icon action-delete pl-2 pr-2" @click="exchangeLang()">
                              <i><img  src="img/icons/common/exchange-alt-solid.svg"/></i>
                          </a>
                          <el-tooltip placement="bottom" :content="$t('tooltip.language.en')">
                            <b-link @click="onTranslate('en')"><country-flag country='gb' size='normal' v-bind:style="lang=='en'? styles.flagFocusStyle:styles.flagNotFocusStyle"/></b-link>   
                          </el-tooltip>                 
                        </b-col>            
                      </b-col>            
                  </b-row>        
                </b-col>
              </b-row>

              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(updateBlog)">
                  <div>
                    <b-row>
                      <b-col lg="6">
                        <b-row>
                          <b-col md="12">
                            <label class="form-control-label required">{{ $t('admin.carousel.image') }}</label>
                            <validation-provider
                              :name="'image' + blog[lang]"
                              :rules="{ required: true }"
                              v-slot="a"
                            >
                            <b-form-input
                              :label="$t('admin.carousel.image')"
                              :placeholder="$t('admin.carousel.browse')"
                              v-model="blog[lang].cln_image"
                              @click="$refs.fileInput.click()"
                              :state="getValidationState(a)"
                              class="as-fileinput"
                              readonly
                            />             
                            <input
                              class="d-none"
                              @change="onFileChange" type="file" ref="fileInput"
                              accept="image/*"
                            />
                            </validation-provider>                  
                          </b-col>
                        </b-row>  
                        <b-row class="mt-3">
                          <b-col md="12">
                            <label class="form-control-label required">{{ $t('admin.carousel.url') }}</label>
                            <validation-provider
                              :name="'url' + blog[lang]"
                            >
                            <b-form-input
                              :label="$t('admin.carousel.url')"
                              :placeholder="$t('admin.carousel.urlplaceholder')"
                              v-model="blog[lang].cln_url"
                            />
                            </validation-provider>                  
                          </b-col>
                        </b-row>                           
                        <b-row class="mt-3">
                          <b-col md="12">
                            <validation-provider
                              :name="'title' + blog[lang]"
                              :rules="{ required: true }"
                              v-slot="b"
                            >                  
                            <b-form-group :label="$t('admin.carousel.title')" label-class="form-control-label required" class="mb-0" label-for="title">
                              <b-form-textarea
                                rows="2"
                                value=""
                                id="title" :placeholder="$t('admin.carousel.titleplaceholder')"
                                v-model="blog[lang].cln_title"
                                :state="getValidationState(b)"
                              ></b-form-textarea>
                            </b-form-group>  
                            </validation-provider>                                
                          </b-col>
                        </b-row>                   
                      </b-col>
                      <b-col lg="6" class="mt-3 mt-lg-0">
                        <label class="form-control-label">{{ $t('admin.carousel.preview') }}</label>
                        <b-card class="image-preview" :style="{ backgroundImage: 'url(' + (url[lang]?url[lang]:'./img/theme/placeholder-image.png') + ')' }">
                          
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>

                  <div align="center" class="pt-3">
                    <button type="submit" class="btn btn-success">{{ $t('admin.carousel.saveandback') }}</button>
                  </div>
                </b-form>
              </validation-observer>
            </card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import { mapActions } from "vuex";
  export default {
    props: {

    },
    data() {
      return {
        id: null,
        lang: Vue.i18n.locale(),
        formValid: {
          en: false,
          fr: false
        },
        url: {
          en: null,
          fr: null
        },
        blog: {
          en: {
            cln_title: '',
            image: null,
            cln_image: '',
            cln_url: ''
          },
          fr: {
            cln_title: '',
            image: null,
            cln_image: '',
            cln_url: ''
          }        
        },
        styles:{
            flagNotFocusStyle:{
              borderRadius:'10px',
              boxShadow: '0 5px 2px -2px #144f56',
              opacity:'0.5'
              
            },
            flagFocusStyle:{
              borderRadius:'10px',
              boxShadow: '0 4px 2px -2px #144f56',
              transform: 'scale(0.6)'
              
            },
            flagColStyle:{
              //backgroundColor:'#e6f8e1',
              width:'fit-content',
              float:'right',
              borderRadius:'2px'
            }

          },
        error: '',
        loading: false
      };
    },
    mounted() {
      this.id = this.$route.params.id;
      if(this.id > 0) this.getBlog(this.id)
    },
    methods: {
      ...mapActions(["CreateCarousel", "UpdateCarousel", "GetCarousel", "UploadImage"]),
      getValidationState({ dirty, validated, valid = null }) {
        let isValid = dirty || validated ? valid : null;
        this.formValid[this.lang] = isValid;
        return isValid;
      },    
      async updateBlog() {
        if(this.id > 0){
          this.loading = true;
          await this.UpdateCarousel({id:this.id, lan:'fr', body:this.blog.fr});
          await this.UpdateCarousel({id:this.id, lan:'en', body:this.blog.en});

          let formData = new FormData();
          formData.append('car_id', this.id);
          if(this.blog.fr.image != null) formData.append('image_fr', this.blog.fr.image);
          if(this.blog.en.image != null) formData.append('image_en', this.blog.en.image);

          await this.UploadImage(formData);
          this.loading = false;
          this.$router.push({ path: '/blogs' })
        }else{
          this.error = '';
          if(!this.formValid.en || !this.formValid.fr){
            this.error = "alert.fillfrandenform";
            return
          };
          this.loading = true;
          await this.CreateCarousel(this.blog)
            .then(
              ({car_id}) => {
                let formData = new FormData();
                formData.append('car_id', car_id);
                formData.append('image_en', this.blog.fr.image);
                formData.append('image_fr', this.blog.en.image);
                this.UploadImage(formData)
                  .then(
                    () => {
                      this.loading = false;
                      this.$router.push({ path: '/blogs' })
                    }
                  ).catch(
                    error => {
                      this.loading = false;
                      console.log(error)
                    }
                  )
              }
            )
            .catch(
              error => {
                this.error = '';
                console.log(error);
              }
            )
        }
      },
      async getBlog(id) {
        this.GetCarousel(id)
          .then(
            data => {
              this.blog = {
                fr: {
                  cln_title: data.fr.cln_title,
                  image: [],
                  cln_image: data.fr.cln_image,
                  cln_url: data.fr.cln_url
                },
                en: {
                  cln_title: data.en.cln_title,
                  image: [],
                  cln_image: data.en.cln_image,
                  cln_url: data.en.cln_url
                }
              }
              this.url.fr = process.env.VUE_APP_APIURL + "image/" + data.fr.cln_image;
              this.url.en = process.env.VUE_APP_APIURL + "image/" + data.en.cln_image;
            }
        )
        .catch(
          error => console.log(error)
        )
      },   
      onFileChange(e) {
        const file = e.target.files[0];
        this.url[this.lang] = file?URL.createObjectURL(file):null;
        this.blog[this.lang].cln_image = file?file.name:'';
        this.blog[this.lang].image = file;

        this.error = '';
      },
      onTranslate(language){
        this.lang=language;
      },
      exchangeLang() {
        this.lang == 'fr'?this.lang = 'en':this.lang = 'fr';
        this.error = '';
      }
    }
  };
</script>
